import React from 'react';
import { BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BookPresentationSection() {
  const contents = ['120 reflexiones profundas y transformadoras.', 'Herramientas para fortalecer tu autoestima.', 'Lecciones para dejar de conformarte con menos.', 'Ejercicios de autoconocimiento.', 'Reflexiones para sanar heridas emocionales.', 'Estrategias para establecer límites sin culpa.', 'Un camino para convertirte nuevamente en tu prioridad.'];
  return <section className="w-full bg-brand-cream py-16 md:py-24 px-4" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-brand-wine mb-12 leading-tight" data-id="element-27">
          ¿Qué encontrarás dentro de MERECES MÁS?
        </h2>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12 border-t-4 border-brand-wine" data-id="element-28">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
            {contents.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-30">
                <div className="mt-1 bg-brand-wine/10 p-2 rounded-lg flex-shrink-0" data-id="element-31">
                  <BookOpen className="w-5 h-5 text-brand-wine" data-id="element-32" />
                </div>
                <span className="text-lg text-gray-700 font-medium leading-relaxed" data-id="element-33">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-34">
          <p className="text-xl text-gray-700 mb-4" data-id="element-35">
            Cada página fue diseñada para ayudarte a reconstruir la relación más
            importante de tu vida:
          </p>
          <p className="font-serif text-3xl md:text-4xl font-bold text-brand-wine" data-id="element-36">
            La relación contigo misma.
          </p>
        </div>

        <CTAButton microtext="SÍ, QUIERO ESTE LIBRO" data-id="element-37" />
      </div>
    </section>;
}